import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { api } from '../lib/api';
export default function AICopilot() {
    const [prompt, setPrompt] = useState('');
    const [flash, setFlash] = useState(false);
    const [busy, setBusy] = useState(false);
    const [out, setOut] = useState(null);
    const [err, setErr] = useState('');
    async function go() {
        setBusy(true);
        setErr('');
        setOut(null);
        try {
            const r = await api('/ai/chat', {
                method: 'POST',
                body: JSON.stringify({ prompt, prefer_flash: flash }),
            });
            setOut(r);
        }
        catch (e) {
            setErr(String(e.message || e));
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("h2", { children: ["AI Copilot ", _jsx("span", { className: "muted", children: "(Vertex AI \u00B7 asia-east2)" })] }), _jsxs("div", { className: "card", children: [_jsx("textarea", { value: prompt, onChange: (e) => setPrompt(e.target.value), placeholder: "\u4F8B\uFF1A\u5206\u6790\u904E\u53BB 30 \u65E5\u65B0\u79DF\u6236\u7559\u5B58\u8DA8\u52E2\uFF0C\u7D66\u51FA\u4E09\u500B\u6539\u5584\u5EFA\u8B70\u3002", style: { width: '100%', minHeight: 120 } }), _jsxs("div", { className: "row", style: { marginTop: 8, justifyContent: 'space-between' }, children: [_jsxs("label", { className: "muted", children: [_jsx("input", { type: "checkbox", checked: flash, onChange: (e) => setFlash(e.target.checked) }), ' ', "\u512A\u5148\u4F7F\u7528 Flash\uFF08\u66F4\u4FBF\u5B9C\uFF09"] }), _jsx("button", { className: "primary", onClick: go, disabled: busy || !prompt.trim(), children: busy ? '思考中…' : '送出' })] })] }), err && _jsx("div", { className: "card", style: { color: '#dc2626' }, children: err }), out && (_jsxs("div", { className: "card", children: [_jsxs("div", { className: "muted", style: { marginBottom: 8 }, children: ["\u6A21\u578B\uFF1A", out.model, " \u00B7 in ", out.tokens_in, " / out ", out.tokens_out, " \u00B7 $", out.cost_hkd, " HKD \u00B7 ", out.latency_ms, "ms"] }), _jsx("div", { style: { whiteSpace: 'pre-wrap' }, children: out.answer })] }))] }));
}
